import React from 'react';
import { Box, Flex } from 'rebass/styled-components';
import { Loader } from '@getro/rombo';
import { useSelector } from 'react-redux';
import { useGetJobBoardSettingsQuery, useUpdateJobBoardSettingsMutation } from 'services/networkV2';
import { trackEvent } from 'helpers/analytics';
import { useGetTalentNetworkSettingsQuery } from 'services/network';
import { SettingsLayoutHeader } from '../../../components/atoms/settingsLayoutHeader';
import { activeNetworkSelector } from '../../../redux/selectors';
import usePageHook from '../../../hooks/usePageHook';
import { JobBoardSettings } from '../components/JobBoardSettings';
import { JobBoardAppearancePanel } from '../components/JobBoardAppearancePanel';
import { JobBoardTnSubscriptionSettings } from './jobBoardTnSubscriptionSettings';
import { TalentDivider } from './talentDivider';

const pageTitle = 'Job board general settings';

const JobBoard = () => {
  const activeNetwork = useSelector(activeNetworkSelector);
  const { data, isLoading: loadingSettings } = useGetJobBoardSettingsQuery();
  const [update] = useUpdateJobBoardSettingsMutation();
  const { data: talentNetworkSettings, isLoading: isLoadingTalentNetworkSettings } = useGetTalentNetworkSettingsQuery();

  usePageHook(pageTitle);

  const loading = loadingSettings || isLoadingTalentNetworkSettings;

  return (
    <Box maxWidth="600px">
      <SettingsLayoutHeader title={pageTitle} description="Easily customize how your job board looks." />
      {loading && (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '400px' }}>
          <Loader />
        </Box>
      )}
      {!loading && (
        <Box pt="32px">
          <Flex sx={{ flexDirection: 'column', gap: '40px' }}>
            <JobBoardSettings
              domain={activeNetwork.url}
              faviconUrl={data?.faviconUrl ?? ''}
              update={async (updates) =>
                update(updates).then(() => {
                  trackEvent('network_settings:edit_job_board_general_settings', {
                    collectionId: activeNetwork.id,
                  });
                })
              }
            />
            <JobBoardAppearancePanel activeNetwork={activeNetwork} />
          </Flex>
          <TalentDivider />
          <JobBoardTnSubscriptionSettings talentNetworkSettings={talentNetworkSettings} />
        </Box>
      )}
    </Box>
  );
};

export default JobBoard;
